<div id="tituloPaginaLoja"
    class="app-titulo-pagina visible-xs">
    <span>Loja - Meus Pedidos</span>
</div>

<div class="col-xs-12 app-banner" style="margin-top: 25px;">
    <img class="hidden-xs" src="assets/img/banners/loja.png" alt="Banner">
    <img class="visible-xs" src="../../assets/img/banners/mobile_loja.png" alt="Banner Loja">
</div>

<div *ngIf="processando" class="text-center">
    <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>

<input id="length-tabela-loja" type="hidden" value="{{pedidos?.length}}">

<div *ngIf="!processando" class="text-center" style="margin-bottom: 50px;">
    <div class="text-center">
        <a (click)="router.navigate(['/loja/vitrine'])" 
        id="btn-resgatar-produtos"
        class="btn app-btn-best-v2">
            <i class="fa fa-shopping-cart"></i> Nova compra
        </a>
    </div>

    <div *ngIf="pedidos !== undefined && pedidos.length"
         class="table-responsive">
        <table id="tabelaLoja" 
            class="table table-striped table-hover">
            <thead>
                <tr>
                    <th>Código</th>
                    <th><span class="glyphicon glyphicon-arrow-down"></span>Data</th>
                    <th>Status</th>
                    <th>Previsão de entrega</th>
                    <th>Pontos</th>
                    <th>Ações</th>
                </tr>
            </thead>
            <tbody id="tabelaLojaBody"> 
                <tr *ngFor="let pedido of pedidos">
                    <td>{{ pedido.id }}</td>
                    <td>{{ pedido.dataSolicitacao | dateFormat:'dd/MM/yyyy HH:mm' }}</td>
                    <td>{{ pedido.status.status }}</td>
                    <td>{{ pedido.previsaoEntrega }}</td>
                    <td>{{ pedido.pontos + pedido.frete.pontos }}</td>
                    <td>
                        <a (click)="visualizarPedido(pedido)"
                           class="btn app-btn-best" >Ver Produtos</a>
                        <!--<a class="btn app-btn-best">Rastrear</a>-->
                    </td> 
                </tr> 
            </tbody>
        </table>
    </div>
</div>
<div class="clearfix"></div>



// WEBPACK FOOTER //
// ./src/app/loja/loja.component.html